import NativeClient from "@/client/native-client";

export interface RootState {
  version: string;
}

export interface CommonState {
  isLoading: boolean;
  apiBaseParams: ApiBaseParams;
  apiError: ApiError | null;
  logId: string | null;
  searchAppliance: string | null;
  attachmentList: AttachmentList | null;
  isFullscreenLoading: boolean;
  pantryCameraImage: PantryCameraImageResult | null;
}

export interface ApiBaseParams {
  token: string | null;
  apiKey: string | null;
  applianceId: string | null;
  appliance: string | null;
  applianceList: ApplianceList | null;
  userAgent: string | null;
  termId: string | null;
}

export interface ApiError {
  type: string | null,
  title: string | null,
  error: Error | null
}

export interface Error {
  message: string | null,
  code: string | null
}

export interface ApiFridgeError {
  code: string | null;
  message: string | null;
}

export class ApplianceData {
  productCode: string;
  applianceId: string;
  geminiId: string;
  uniqueId: string;
  eoj: string | null;
  constructor() {
    this.productCode = "";
    this.applianceId = "";
    this.geminiId = "";
    this.uniqueId = "";
    this.eoj = null;
  }
}

export class AttachmentList {
  attachmentList: Array<AttachmentData>;
  constructor() {
    this.attachmentList = [];
  }
}

export class AttachmentData {
  attachmentCode: string;
  activated: boolean;
  constructor() {
    this.attachmentCode = "";
    this.activated = false;
  }
}

export class ApplianceList {
  applianceList: Array<ApplianceData>;
  constructor() {
    this.applianceList = [];
  }
}

export interface SearchApplianceData {
  productCode: string;
  check: boolean;
  applianceId: string;
  geminiId: string;
  uniqueId: string;
}

export class SearchApplianceList {
  applianceList: Array<SearchApplianceData>;
  constructor() {
    this.applianceList = [];
  }
}

// BeaconLog
export class BeaconLogInfo {
  pageId: string;
  objectId: string | null;
  viewedItems: string[];

  constructor(pageId: string, objectId: string | null, viewedItems: string[]) {
    this.pageId = pageId;
    this.objectId = objectId;
    this.viewedItems = viewedItems;
  }
}

// UpdatePage
export class UpdatePageInfo {
  myList: boolean;
  sendedHistory: boolean;
  viewedHistory: boolean;
  favoriteFoods: boolean;
  constructor() {
    this.myList = false;
    this.sendedHistory = false;
    this.viewedHistory = false;
    this.favoriteFoods = false;
  }
}

export class RecipeComment {
  total_number: number;
  comments: Array<RecipeCommentItem>;
  constructor() {
    this.total_number = 0;
    this.comments = [];
  }
}

export class RecipeCommentItem {
  text: string;
  image: string;
  created: string;
  name: string;
  user_main_image: string;
  reply: boolean;
  constructor() {
    this.text = "";
    this.image = "";
    this.created = "";
    this.name = "";
    this.user_main_image = "";
    this.reply = false;
  }
}

export class RecipeCommentItemData {
  id: number;
  comment: RecipeCommentItem;
  isDivider: boolean;
  isGradient: boolean;
  constructor(id: number, comment: RecipeCommentItem, isDivider: boolean, isGradient: boolean) {
    this.id = id;
    this.comment = comment;
    this.isDivider = isDivider;
    this.isGradient = isGradient;
  }
}

// 食材追加の部品
export class SelectingIngredientListDataItem {
  id: number | null;  // 存在しない場合もある
  name: string;
  imageUrl: string;
  isSelect: boolean;
  isShowButton: boolean;

  constructor() {
    this.id = 0;
    this.name = "";
    this.imageUrl = "";
    this.isSelect = false;
    this.isShowButton = false;
  }
}

export interface Product {
  applianceId: string;
  uniqueId: string;
  eoj: string;
  categoryId: string;
  icon: string;
  nickname: string;
  productId: string;
  productCode: string;
  productName: string;
  geminiId: string;
}

export class Products {
  products: Array<Product>;
  constructor() {
    this.products = [];
  }
}

export class PantryCameraImage {
  fileName: string;
  imageData: string | null;

  constructor(fileName: string, imageData: string | null) {
    this.fileName = fileName;
    this.imageData = imageData;
  }
}

export class PantryCameraImageResult {
  fileName: string | null;
  imageData: string | null;

  constructor(fileName: string) {
    this.fileName = null;
    this.imageData = null;
  }
}

export class LoadPantryCameraImage {
  fileName: string;
  constructor(fileName: string) {
    this.fileName = fileName;
  }
}
